let assistantOpen = false
let restoreTimer = null

function cancelPendingRestore() {
    if (restoreTimer === null) return

    clearTimeout(restoreTimer)
    restoreTimer = null
}

export function isFrigadeAssistantOpen() {
    return assistantOpen
}

export function showFrigadeAssistant() {
    if (typeof window.FrigadeAssistant?.show !== 'function') return

    cancelPendingRestore()
    assistantOpen = true
    window.FrigadeAssistant.show()
}

export function hideFrigadeAssistant() {
    cancelPendingRestore()
    assistantOpen = false
    window.FrigadeAssistant?.hide?.()
}

export function restoreFrigadeAssistant(previousShow, attemptsRemaining = 40) {
    cancelPendingRestore()

    const restoreWhenReady = () => {
        restoreTimer = null
        if (!assistantOpen) return

        const currentShow = window.FrigadeAssistant?.show
        if (typeof currentShow === 'function' && currentShow !== previousShow) {
            showFrigadeAssistant()
            return
        }

        if (attemptsRemaining > 0) {
            attemptsRemaining--
            restoreTimer = setTimeout(restoreWhenReady, 50)
        }
    }

    restoreWhenReady()
}
